<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Header -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-profile-header">
            <div class="card-header trainer-card-header">
              <h4 class="card-title trainer-title">
                <i class="nc-icon nc-single-02"></i>
                Mi Perfil Profesional
              </h4>
              <p class="card-category trainer-subtitle">
                Gestiona tu información profesional y disponibilidad
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Información Personal y Profesional -->
      <div class="row">
        <div class="col-lg-4">
          <!-- Foto de Perfil -->
          <div class="card trainer-card">
            <div class="card-body text-center">
              <div class="trainer-avatar-section">
                <div class="trainer-avatar">
                  <img src="/static/img/faces/avatar.png" alt="Foto de perfil" class="trainer-avatar-img">
                  <button class="btn btn-sm trainer-btn-primary trainer-change-photo">
                    <i class="nc-icon nc-camera-compact"></i>
                  </button>
                </div>
                <h5 class="trainer-name">Carlos Rodriguez</h5>
                <p class="trainer-specialty">Personal Trainer Certificado</p>
                <div class="trainer-rating">
                  <i class="fa fa-star text-warning"></i>
                  <i class="fa fa-star text-warning"></i>
                  <i class="fa fa-star text-warning"></i>
                  <i class="fa fa-star text-warning"></i>
                  <i class="fa fa-star text-warning"></i>
                  <span class="ml-2">4.9 (127 evaluaciones)</span>
                </div>
              </div>
              
              <hr>
              
              <div class="trainer-stats">
                <div class="row">
                  <div class="col-4">
                    <h6 class="trainer-stat-number">142</h6>
                    <span class="trainer-stat-label">Clientes</span>
                  </div>
                  <div class="col-4">
                    <h6 class="trainer-stat-number">3</h6>
                    <span class="trainer-stat-label">Años Exp.</span>
                  </div>
                  <div class="col-4">
                    <h6 class="trainer-stat-number">89%</h6>
                    <span class="trainer-stat-label">Éxito</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Certificaciones -->
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Certificaciones</h6>
            </div>
            <div class="card-body">
              <div class="trainer-certification">
                <i class="nc-icon nc-trophy text-warning"></i>
                <div>
                  <strong>ACSM Personal Trainer</strong>
                  <br><small>Vigente hasta: Dic 2025</small>
                </div>
              </div>
              <div class="trainer-certification">
                <i class="nc-icon nc-trophy text-success"></i>
                <div>
                  <strong>Nutrición Deportiva</strong>
                  <br><small>Vigente hasta: Jun 2024</small>
                </div>
              </div>
              <div class="trainer-certification">
                <i class="nc-icon nc-trophy text-info"></i>
                <div>
                  <strong>Rehabilitación Funcional</strong>
                  <br><small>Vigente hasta: Mar 2025</small>
                </div>
              </div>
              <button class="btn btn-outline-primary btn-sm mt-3 w-100">
                <i class="nc-icon nc-simple-add"></i> Añadir Certificación
              </button>
            </div>
          </div>
        </div>
        
        <div class="col-lg-8">
          <!-- Información Personal -->
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Información Personal</h6>
            </div>
            <div class="card-body">
              <form>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Nombre Completo</label>
                      <input type="text" class="form-control" value="Carlos Rodriguez Mendez" placeholder="Nombre completo">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Email</label>
                      <input type="email" class="form-control" value="carlos.rodriguez@centralgym.com" placeholder="Email">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Teléfono</label>
                      <input type="tel" class="form-control" value="+56 9 8765 4321" placeholder="Teléfono">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Fecha de Nacimiento</label>
                      <input type="date" class="form-control" value="1990-05-15">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Especialidades</label>
                  <div class="trainer-specialties">
                    <span class="badge trainer-badge-specialty">Fuerza</span>
                    <span class="badge trainer-badge-specialty">Resistencia</span>
                    <span class="badge trainer-badge-specialty">Rehabilitación</span>
                    <span class="badge trainer-badge-specialty">Nutrición</span>
                    <span class="badge badge-light">+ Añadir</span>
                  </div>
                </div>
                <div class="form-group">
                  <label>Biografía Profesional</label>
                  <textarea class="form-control" rows="4" placeholder="Describe tu experiencia y metodología...">Personal Trainer certificado con más de 3 años de experiencia. Especializado en entrenamiento funcional, rehabilitación y nutrición deportiva. Mi enfoque se basa en crear programas personalizados que se adapten a las necesidades y objetivos específicos de cada cliente.</textarea>
                </div>
                <button type="submit" class="btn trainer-btn-primary">
                  <i class="nc-icon nc-check-2"></i> Guardar Cambios
                </button>
              </form>
            </div>
          </div>
          
          <!-- Configuración de Disponibilidad -->
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Disponibilidad y Horarios</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <h6 class="mb-3">Horarios de Trabajo</h6>
                  <div class="trainer-schedule-day" v-for="day in schedule" :key="day.name">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" :id="day.name" v-model="day.active">
                      <label class="form-check-label" :for="day.name">
                        {{ day.label }}
                      </label>
                    </div>
                    <div v-if="day.active" class="trainer-time-inputs">
                      <input type="time" class="form-control form-control-sm" v-model="day.startTime">
                      <span>a</span>
                      <input type="time" class="form-control form-control-sm" v-model="day.endTime">
                    </div>
                  </div>
                </div>
                
                <div class="col-md-6">
                  <h6 class="mb-3">Configuración de Sesiones</h6>
                  <div class="form-group">
                    <label>Duración por Sesión (min)</label>
                    <select class="form-control">
                      <option value="30">30 minutos</option>
                      <option value="45">45 minutos</option>
                      <option value="60" selected>60 minutos</option>
                      <option value="90">90 minutos</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Tiempo entre Sesiones (min)</label>
                    <select class="form-control">
                      <option value="0">Sin pausa</option>
                      <option value="15" selected>15 minutos</option>
                      <option value="30">30 minutos</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Máximo Clientes por Día</label>
                    <input type="number" class="form-control" value="8" min="1" max="20">
                  </div>
                  <div class="form-group">
                    <label>Tarifa por Sesión</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">$</span>
                      </div>
                      <input type="number" class="form-control" value="45000" placeholder="45000">
                    </div>
                  </div>
                </div>
              </div>
              
              <hr>
              
              <div class="trainer-availability-summary">
                <h6>Resumen de Disponibilidad</h6>
                <div class="row">
                  <div class="col-md-3">
                    <div class="trainer-summary-item">
                      <i class="nc-icon nc-calendar-60 text-primary"></i>
                      <span>5 días activos</span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="trainer-summary-item">
                      <i class="nc-icon nc-time-alarm text-success"></i>
                      <span>40 hrs/semana</span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="trainer-summary-item">
                      <i class="nc-icon nc-single-02 text-warning"></i>
                      <span>40 sesiones máx</span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="trainer-summary-item">
                      <i class="nc-icon nc-money-coins text-info"></i>
                      <span>$1.800k potencial</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <button type="submit" class="btn trainer-btn-primary mt-3">
                <i class="nc-icon nc-check-2"></i> Actualizar Disponibilidad
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainerProfile',
  data() {
    return {
      schedule: [
        { name: 'monday', label: 'Lunes', active: true, startTime: '09:00', endTime: '17:00' },
        { name: 'tuesday', label: 'Martes', active: true, startTime: '09:00', endTime: '17:00' },
        { name: 'wednesday', label: 'Miércoles', active: true, startTime: '09:00', endTime: '17:00' },
        { name: 'thursday', label: 'Jueves', active: true, startTime: '09:00', endTime: '17:00' },
        { name: 'friday', label: 'Viernes', active: true, startTime: '09:00', endTime: '17:00' },
        { name: 'saturday', label: 'Sábado', active: false, startTime: '10:00', endTime: '14:00' },
        { name: 'sunday', label: 'Domingo', active: false, startTime: '10:00', endTime: '14:00' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  --trainer-primary: #9ACD32;
  --trainer-secondary: #7CB342;
  --trainer-accent: #8BC34A;
  --trainer-dark: #689F38;
  --trainer-light: #DCEDC8;
  --trainer-bg: #F1F8E9;
}

.trainer-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  margin-bottom: 20px;
  
  .card-header {
    background: var(--trainer-bg);
    border-bottom: 1px solid #dee2e6;
    
    .card-title {
      color: var(--trainer-dark);
      font-weight: 600;
      margin: 0;
    }
  }
}

.trainer-profile-header {
  background: linear-gradient(135deg, var(--trainer-primary), var(--trainer-secondary));
  color: white;
  border: none;
  box-shadow: 0 4px 20px 0px rgba(154, 205, 50, 0.14), 0 7px 10px -5px rgba(154, 205, 50, 0.4);
  
  .trainer-card-header {
    background: transparent;
    border: none;
  }
  
  .trainer-title {
    color: white;
    font-weight: 500;
    margin-bottom: 5px;
    
    i {
      margin-right: 10px;
    }
  }
  
  .trainer-subtitle {
    color: rgba(255,255,255,0.8);
    margin: 0;
  }
}

.trainer-avatar-section {
  .trainer-avatar {
    position: relative;
    display: inline-block;
    margin-bottom: 15px;
    
    .trainer-avatar-img {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      border: 4px solid var(--trainer-light);
      object-fit: cover;
    }
    
    .trainer-change-photo {
      position: absolute;
      bottom: 5px;
      right: 5px;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  
  .trainer-name {
    color: var(--trainer-dark);
    font-weight: 600;
    margin-bottom: 5px;
  }
  
  .trainer-specialty {
    color: #666;
    margin-bottom: 10px;
  }
  
  .trainer-rating {
    font-size: 14px;
    color: #555;
  }
}

.trainer-stats {
  .trainer-stat-number {
    font-size: 24px;
    font-weight: 700;
    color: var(--trainer-primary);
    margin-bottom: 5px;
  }
  
  .trainer-stat-label {
    font-size: 12px;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}

.trainer-certification {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  
  i {
    font-size: 20px;
    margin-right: 15px;
  }
  
  strong {
    color: var(--trainer-dark);
  }
  
  small {
    color: #666;
  }
}

.trainer-specialties {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  
  .trainer-badge-specialty {
    background: var(--trainer-primary);
    color: white;
    padding: 5px 12px;
    border-radius: 15px;
    font-size: 12px;
  }
}

.trainer-schedule-day {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  
  .form-check {
    margin: 0;
  }
  
  .trainer-time-inputs {
    display: flex;
    align-items: center;
    gap: 10px;
    
    span {
      font-size: 14px;
      color: #666;
    }
    
    input {
      width: 80px;
    }
  }
}

.trainer-availability-summary {
  background: var(--trainer-bg);
  padding: 20px;
  border-radius: 8px;
  
  h6 {
    color: var(--trainer-dark);
    margin-bottom: 15px;
  }
  
  .trainer-summary-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    
    i {
      font-size: 18px;
      margin-right: 10px;
    }
    
    span {
      font-size: 14px;
      font-weight: 500;
    }
  }
}

.trainer-btn-primary {
  background: var(--trainer-primary);
  border-color: var(--trainer-primary);
  color: white;
  
  &:hover {
    background: var(--trainer-secondary);
    border-color: var(--trainer-secondary);
  }
}

.form-group label {
  color: var(--trainer-dark);
  font-weight: 500;
  margin-bottom: 5px;
}

.form-control {
  border: 2px solid #e9ecef;
  border-radius: 6px;
  
  &:focus {
    border-color: var(--trainer-primary);
    box-shadow: 0 0 0 0.2rem rgba(154, 205, 50, 0.25);
  }
}
</style>